/**
 * Units and formatting settings depending on language
 */
var LocaleSetting = (function () {
    /**
     * Constructor
     * @param {string} [chunkDelimiter='.']       Delimiter that occurs after every third digit
     * @param {string} [decimalDelimiter=',']     Delimiter that separates integer and decimals
     * @param {boolean} [symbolAfter=true]        True if currency symbol should be displayed after value
     * @param {string} [millionSuffix=' Mio.'     Abbreviation of 'million' that is displayed if value is 1 million or greater
     * @param {string} [dateFormatShort='DD.MM.'] Short form of date (day and month)
     */
    function LocaleSetting(chunkDelimiter, decimalDelimiter, symbolAfter, millionSuffix, dateFormatShort) {
        if (chunkDelimiter === void 0) { chunkDelimiter = '.'; }
        if (decimalDelimiter === void 0) { decimalDelimiter = ','; }
        if (symbolAfter === void 0) { symbolAfter = true; }
        if (millionSuffix === void 0) { millionSuffix = ' Mio.'; }
        if (dateFormatShort === void 0) { dateFormatShort = 'DD.MM.'; }
        this.chunkDelimiter = chunkDelimiter;
        this.decimalDelimiter = decimalDelimiter;
        this.symbolAfter = symbolAfter;
        this.millionSuffix = millionSuffix;
        this.dateFormatShort = dateFormatShort;
    }
    return LocaleSetting;
}());
export { LocaleSetting };



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/shared/models/LocaleSettings.ts.pre-build-optimizer.js